import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as CollectionActions from '../actions/collections.action';
import { switchMap, map, catchError, tap, withLatestFrom } from 'rxjs/operators';
import { CollectionsService } from '../../services';
import { Go } from 'src/app/store';
import { Store } from '@ngrx/store';
import { getActiveLanguageNoCulture } from '@teamfoster/sdk/language-ngrx';

@Injectable()
export class CollectionsEffects {
  constructor(private actions$: Actions, private service: CollectionsService, private store: Store) {}

  LoadCollections$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CollectionActions.LoadCollections),
      withLatestFrom(this.store.select(getActiveLanguageNoCulture)),
      switchMap(([, lang]) =>
        this.service.getCollections(lang).pipe(
          map(collections => CollectionActions.LoadCollectionsSuccess({ collections })),
          catchError(error => of(CollectionActions.LoadCollectionsFail({ error })))
        )
      )
    );
  });

  LoadCollectionByHandle$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CollectionActions.LoadCollectionByHandle),
      withLatestFrom(this.store.select(getActiveLanguageNoCulture)),
      switchMap(([{ handle }, lang]) =>
        this.service.getCollectionByHandle(handle, lang).pipe(
          map(collection => {
            if (!collection) {
              return CollectionActions.LoadCollectionByHandleFail({ error: '404' });
            }

            return CollectionActions.LoadCollectionByHandleSuccess({ collection, handle });
          }),
          catchError(error => of(CollectionActions.LoadCollectionByHandleFail({ error })))
        )
      )
    );
  });

  LoadCollectionFail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CollectionActions.LoadCollectionByHandleFail),
      map(({ error }) => {
        return Go({ path: ['/404'], extras: { skipLocationChange: true } });
      })
    );
  });
}
